import { Component, OnInit, ViewChild } from '@angular/core';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { OfferService } from '../shared/services/offer-services/offer.service';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';

@Component({
  selector: 'app-sign-on-the-spot',
  templateUrl: './sign-on-the-spot.component.html',
  styleUrls: ['./sign-on-the-spot.component.sass']
})
export class SignOnTheSpotComponent implements OnInit {
  @ViewChild('offerDetailsModal', { static: false }) private offerDetailsModal;
  @ViewChild('offerDetailsModal2', { static: false }) private offerDetailsModal2;
  @ViewChild('questionnarieDetailsModal', { static: false }) private questionnarieDetailsModal;
  @ViewChild('questionnarieDetailsModal2', { static: false }) private questionnarieDetailsModal2;
  @ViewChild('signModal', { static: false }) private signModal;
  @ViewChild('signModal2', { static: false }) private signModal2;
  @ViewChild('signModal3', { static: false }) private signModal3;
  @ViewChild('signModal4', { static: false }) private signModal4;
  @ViewChild('succesModal', { static: false }) private succesModal;
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  @ViewChild(SignaturePad, { static: false }) signaturePad2: SignaturePad;
  @ViewChild(SignaturePad, { static: false }) signaturePad3: SignaturePad;
  @ViewChild(SignaturePad, { static: false }) signaturePad4: SignaturePad;

  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;
  faArrowDown = faArrowDown;

  signaturePadOptions = {
    'minWidth': 2,
    'canvasWidth': 735,
    'canvasHeight': 300
  };

  offerID;
  offer;
  signer;

  constructor(private activatedRoute: ActivatedRoute, private modalService: NgbModal, private offerService: OfferService) {
    this.offerID = parseInt(this.activatedRoute.snapshot.paramMap.get('offerid'))
    console.log(this.offerID)
    this.offerService.getOne(this.offerID)
      .then(
        (x: any) => {
          console.log(x)
          this.offer = x;
        }
      )
  }

  ngOnInit() {
  }
  pdfSrc1;
  pdfSrc2;
  pdfSrc3;
  pdfSrc4;
  signDocument() {
    this.modalService.open(this.offerDetailsModal, { size: 'xl', backdrop: 'static' })
    this.offerService.previewDocument(this.offerID, 0, 0)
      .then(
        (x: any) => {
          console.log(x)
          let pdfFile = new Blob([x.body], { type: 'application/pdf' });
          let urlPdf = window.URL.createObjectURL(pdfFile)
          this.pdfSrc1 = urlPdf
          document.querySelector('iframe').src = urlPdf + "#zoom=130&toolbar=0"
          console.log(urlPdf);
        }
      )
  }
  signDocument2() {
    this.modalService.open(this.questionnarieDetailsModal, { size: 'xl', backdrop: 'static' })
    this.offerService.previewDocument(this.offerID, 1, 0)
      .then(
        (x: any) => {
          console.log(x)
          let pdfFile = new Blob([x.body], { type: 'application/pdf' });
          let urlPdf = window.URL.createObjectURL(pdfFile)
          this.pdfSrc2 = urlPdf
          document.querySelector('iframe').src = urlPdf + "#zoom=130&toolbar=0"
          console.log(urlPdf);
        }
      )
  }
  signDocument3() {
    this.modalService.open(this.offerDetailsModal2, { size: 'xl', backdrop: 'static' })
    this.offerService.previewDocument(this.offerID, 0, 1)
      .then(
        (x: any) => {
          console.log(x)
          let pdfFile = new Blob([x.body], { type: 'application/pdf' });
          let urlPdf = window.URL.createObjectURL(pdfFile)
          this.pdfSrc3 = urlPdf
          document.querySelector('iframe').src = urlPdf + "#zoom=130&toolbar=0"
          console.log(urlPdf);
        }
      )
  }
  signDocument4() {
    this.modalService.open(this.questionnarieDetailsModal2, { size: 'xl', backdrop: 'static' })
    this.offerService.previewDocument(this.offerID, 1, 1)
      .then(
        (x: any) => {
          console.log(x)
          let pdfFile = new Blob([x.body], { type: 'application/pdf' });
          let urlPdf = window.URL.createObjectURL(pdfFile)
          this.pdfSrc4 = urlPdf
          document.querySelector('iframe').src = urlPdf + "#zoom=130&toolbar=0"
          console.log(urlPdf);
        }
      )
  }

  openSignModal() {
    this.modalService.open(this.signModal, { size: 'lg', backdrop: 'static' })
  }
  openSignModal2() {
    this.modalService.open(this.signModal2, { size: 'lg', backdrop: 'static' })
  }
  openSignModal3() {
    this.modalService.open(this.signModal3, { size: 'lg', backdrop: 'static' })
  }
  openSignModal4() {
    this.modalService.open(this.signModal4, { size: 'lg', backdrop: 'static' })
  }

  completeSigning(sign) {
    let image = sign.toDataURL()
    this.offerService.signOTPDocument(this.offerID, 0, 0, image, 0)
      .then(
        (x: any) => {
          console.log(x);
          this.offer = x;
          this.modalService.dismissAll()
          if (x.contractorIsInsuree) {
            if (x.contractorFirstSignature && x.contractorSecondSignature) {
              this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
            }
          } else {
            if (x.contractorFirstSignature && x.contractorSecondSignature && x.insureeFirstSignature && x.insureeSecondSignature) {
              this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
            }
          }
        }
      )
  }
  completeSigning2(sign) {
    let image = sign.toDataURL()
    this.offerService.signOTPDocument(this.offerID, 0, 1, image, 0)
      .then(
        (x: any) => {
          console.log(x);
          this.offer = x;
          this.modalService.dismissAll()
          if (x.contractorIsInsuree) {
            if (x.contractorFirstSignature && x.contractorSecondSignature) {
              this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
            }
          } else {
            if (x.contractorFirstSignature && x.contractorSecondSignature && x.insureeFirstSignature && x.insureeSecondSignature) {
              this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
            }
          }
        }
      )
  }
  completeSigning3(sign) {
    let image = sign.toDataURL()
    this.offerService.signOTPDocument(this.offerID, 1, 0, image, 0)
      .then(
        (x: any) => {
          console.log(x);
          this.offer = x;
          this.modalService.dismissAll()
          if (x.contractorIsInsuree) {
            if (x.contractorFirstSignature && x.contractorSecondSignature) {
              this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
            }
          } else {
            if (x.contractorFirstSignature && x.contractorSecondSignature && x.insureeFirstSignature && x.insureeSecondSignature) {
              this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
            }
          }
        }
      )
  }
  completeSigning4(sign) {
    let image = sign.toDataURL()
    this.offerService.signOTPDocument(this.offerID, 1, 1, image, 0)
      .then(
        (x: any) => {
          console.log(x);
          this.offer = x;
          this.modalService.dismissAll()
          if (x.contractorIsInsuree) {
            if (x.contractorFirstSignature && x.contractorSecondSignature) {
              this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
            }
          } else {
            if (x.contractorFirstSignature && x.contractorSecondSignature && x.insureeFirstSignature && x.insureeSecondSignature) {
              this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
            }
          }
        }
      )
  }

  clearSign(sign) {
    sign.clear();
  }

}
